module.exports = __webpack_public_path__ + "static/media/Metagross_gaussian2.9613cf8c.png";